// ============================================================
// usePlateState - what every plate reads off its target's conditions (plan
// body-map S1-S3): the one record of the states it draws (plateState, the
// only reader of the codes), the svg's `data-states` naming them, and the
// fire's glow round the plate - the one look kept from the old map (the
// plan's "fire drop-shadow inline on the svg"). Death's dimming is the
// plate's own layers'; nothing else here looks at the codes.
// ============================================================

import { useMemo, type CSSProperties } from 'react';
import { activeStates, plateState, type PlateState } from '../../engine/plate/plateState';

/** The fire's glow round a burning plate. */
const fireGlow = (s: PlateState): CSSProperties =>
  s.fire ? { filter: 'drop-shadow(0 0 6px var(--plate-fire-glow))' } : {};

export default function usePlateState(conditions: readonly string[] | undefined) {
  const state = useMemo(() => plateState(conditions ?? []), [conditions]);
  return { state, dataStates: activeStates(state).join(' ') || undefined, glow: fireGlow(state) };
}
